import request from 'utils/request'
import {stringify} from 'qs'
import {format} from 'utils'
import api from './api'

export async function countStat(params) {
    return request(`${api.countStat.url}?${stringify(params)}`)
}

export async function getStatList(payload) {
    return request(`${api.getStatList.url}?${stringify(payload)}`)
}

export async function getPostStatList(payload) {
    const url = format(api.getPostStatList.url, {id: payload.id})
    return request(`${url}?${stringify(payload)}`)
}

export async function getCustomerStat() {
    return request(api.getCustomerStat.url)
}

export async function getRankList(payload) {
    return request(`${api.getRankList.url}?${stringify(payload)}`)
}

export async function getMomentConfig() {
    return request(api.getMomentConfig.url)
}

export async function editMomentConfig(payload) {
    return request(`${api.editMomentConfig.url}`, {
        method: api.editMomentConfig.type,
        body: payload.body,
    })
}

// 导出数据
export async function exportData(params) {
    return request(`${api.exportData.url}${stringify(params, {addQueryPrefix: true})}`, null, {
        returnResponse: true,
    })
}

// 朋友圈详情
export async function getMomentDetail(payload) {
    return request(format(api.getMomentDetail.url, {id: payload.id}))
}

export async function businessMomentsExport(payload = {}) {
    return request(`${api.businessMomentsExport.url}`, {
        method: api.businessMomentsExport.type,
        body: payload.body ?? {},
    })
}
